import { generateChart } from './DefaultChart'
import { reactiveData } from './mixins/data-update'
import { offsetPlugin } from './extra'
import 'chartjs-adapter-date-fns'
import { parse, format, parseJSON } from 'date-fns'

const BarChart = generateChart('bar-chart-2', 'bar')

const defaultChartData = (canvasCtx) => ({
    datasets: [
        {
            backgroundColor: '#30A7FE',
            // maxBarThickness: 15,
            borderRadius: 8,
            // barPercentage: .1,
            // categoryPercentage: .1,
            data: []
        }
    ]
})

export default {
    extends: BarChart,
    mixins: [reactiveData],
    props: {
        dataToRender: {
            type: Array,
            default: () => [],
            required: true
        }
    },
    watch: {
        dataToRender: {
            handler: function (newData, oldData) {
                // if (!this.chartData) this.initChart();
                if (JSON.stringify(newData) !== JSON.stringify(oldData)) {
                    if (newData.length > 0) {
                        setTimeout(this.fillData.bind(this, [...newData, {x: 10000, y: 10000 }]), 0)
                    } else {
                        setTimeout(this.fillData.bind(this, newData), 0)
                    }
                }
            },
            deep: true,
            immediate: true
        }
    },
    data() {
        return {
            chartData: null,
            options: {
                onResize: function (chart, { width, height }) {
                    if (!chart.options.scales.yAxis) return
                    if (width < 600) {
                        chart.options.maintainAspectRatio = false
                        chart.options.scales.yAxis.ticks.display = false
                    } else {
                        chart.options.scales.yAxis.ticks.display = true
                    }
                },
                scales: {
                    xAxis: {
                        offset: true,
                        bounds: 'data',
                        categoryPercentage: 1,
                        barPercentage: 1,
                        display: true,
                        beginAtZero: false,
                        grid: {
                            display: false
                            // offset: false,
                        },
                        ticks: {
                            // labelOffset: -60,
                            crossAlign: 'center',
                            padding: 16,
                            color: 'white',
                            font: {
                                family: 'Montserrat',
                                weight: 600
                            },
                            beginAtZero: false
                        }
                        // type: 'time',
                        // time: {
                        //
                        //     source: 'data',
                        //     stepSize: 1,
                        //     unit: 'year',
                        //     parser: function (dateString) {
                        //         return parse(dateString, 'y/M', new Date())
                        //     }
                        // }
                    },
                    yAxis: {
                        beginAtZero: false,
                        grid: {
                            drawBorder: false,
                            color: '#6D818F'
                            // offset: true
                        },
                        ticks: {
                            beginAtZero: true,
                            color: 'white',
                            font: {
                                family: 'Montserrat',
                                weight: 600
                            },
                            // autoSkipPadding: 84,
                            padding: 44,
                            // labelOffset: -15,
                            callback: function (val, index) {
                                // Hide the label of every 2nd dataset
                                return '€' + this.getLabelForValue(val)
                            }
                            // stepSize: 84
                        }
                    }
                },
                animation: {
                    easing: 'easeInOutBack'
                },
                plugins: {
                    legend: {
                        display: false
                    },
                    tooltip: {
                        displayColors: false,
                        yAlign: 'bottom',
                        cornerRadius: 8,
                        caretPadding: 8,
                        caretSize: 8,
                        backgroundColor: 'white',
                        bodyFont: {
                            family: 'Open Sans',
                            weight: 400,
                            size: 14,
                            lineHeight: 1
                        },
                        bodySpacing: 0,
                        padding: {
                            left: 20,
                            right: 20,
                            top: 8,
                            bottom: 6
                        },
                        titleSpacing: 0,
                        titleColor: '#30A7FE',
                        titleAlign: 'center',
                        titleMarginBottom: 3,
                        titleFont: {
                            lineHeight: 1,
                            family: 'Open Sans',
                            size: 16,
                            weight: 400
                        },
                        bodyAlign: 'center',
                        callbacks: {
                            beforeTitle: function () { },
                            title: function (context) {
                                // debugger;
                                let label = ''
                                if (context[0].parsed.y !== null) {
                                    label = new Intl.NumberFormat('en-US', {
                                        style: 'currency',
                                        currency: 'EUR',
                                        maximumFractionDigits: 0
                                    }).format(context[0].parsed.y)
                                }

                                return label
                            },
                            labelTextColor: function () {
                                return 'black'
                            },
                            beforeLabel: function (context) {
                                //   return "hey";
                            },
                            label: function (context) {
                                const label = context.label || ''

                                if (label) {
                                    // debugger
                                    // label = format(parse(label, 'LLL d, y, hh:m:ss aaaa', new Date()), 'd.M.Y')
                                }
                                return label
                            }
                        }
                    }
                },
                responsive: true,
                maintainAspectRatio: false
            }
        }
    },
    mounted() {
        this.renderChart(this.chartData, this.options, [offsetPlugin])
    },
    methods: {
        fillData(data = []) {
            this.chartData = defaultChartData()
            this.chartData.datasets[0].data = data
        }
    }
}
